import Skeleton from "react-loading-skeleton";

const TransactionRowComponentSkeleton = () => {
  return (
    <div className="flex flex-row border-b border-b-border-table py-[8px]">
      {/* Time */}
      <div className="flex flex-row items-center place-content-start w-[50%]">
        <Skeleton
          width={18}
          height={18}
          circle
          className="mr-[8px]"
          containerClassName="custom-className"
        />
        <div className="flex flex-col">
          <Skeleton
            width={50}
            height={12}
            className="mb-[4px]"
            containerClassName="custom-className"
          />
          <div className="flex flex-row">
            <Skeleton
              width={25}
              height={10}
              className="mr-[4px]"
              containerClassName="custom-className"
            />
            <Skeleton
              width={30}
              height={10}
              containerClassName="custom-className"
            />
          </div>
        </div>
      </div>
      {/* Token */}
      <div className="flex flex-row items-center place-content-start w-[20%]">
        <Skeleton
          width={18}
          height={18}
          circle
          className="mr-[8px]"
          containerClassName="custom-className"
        />
        <div className="flex flex-col">
          <Skeleton
            width={40}
            height={10}
            containerClassName="custom-className"
          />{" "}
          <Skeleton
            width={40}
            height={10}
            containerClassName="custom-className"
          />
        </div>
      </div>
      {/* Amount */}
      <div className="flex flex-col justify-end w-[30%]">
        <div className="flex items-center justify-end">
          <Skeleton
            width={40}
            height={10}
            containerClassName="custom-className"
          />
        </div>
        <div className={`flex flex-row items-center justify-end`}>
          <Skeleton
            width={40}
            height={10}
            containerClassName="custom-className"
          />
        </div>
      </div>
    </div>
  );
};

export default TransactionRowComponentSkeleton;
